import { Card, CardHeader } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import committeeService from "./committee.service";
import logger from "../../services/logger";
import OrgContext from "../app-context";
import BackButton from "../common/backButton";
import { getDynamicFormJson } from "../common/dynamicFormService";
import Form from "../common/form";
import {
  getFormButtonText,
  getFormTitleText,
  getJoiSchema,
  getStateObject,
} from "../common/formUtils";

class CommitteeForm extends Form {
  constructor() {
    super();
    this.formJson = getDynamicFormJson("committee");
    this.state = {
      data: getStateObject(this.formJson.groups),
      errors: {},
      dropDowns: {},
    };
    this.schema = getJoiSchema(this.formJson.groups);
  } 
   
  async populateForm() {
    // const id = this.props.match.params.id;
    const id = this.props.id;

    if (id === "new") return;
    try {
      const { data } = await committeeService.get(id);
      this.mapToViewModel(data);
    } catch (ex) { }
  }

  async componentDidMount() {
    await this.populateForm();
  }

  doSubmit = async (id) => {
    try {
      if (id === "new") await committeeService.create(this.state.data);
      else await committeeService.update(this.state.data);
      // this.props.history.goBack();
      this.props.onSave();

    } catch (ex) {
      logger.log(ex.response.data.message);
    }
  };

  render() {
    const { t } = this.props;
    const { dropDowns } = this.state;
    // const id = this.props.match.params.id;
    const id = this.props.id;


    const buttonText = getFormButtonText(id);

    const titleText = getFormTitleText(id, this.formJson.alias);
    return (
      <Card>
          <CardHeader title={t(titleText)} action={<BackButton {...this.props} />} />
        <form onSubmit={(event) => this.handleSubmit(event, id)}>

          {this.renderForm(this.formJson, dropDowns)}

        </form>
      </Card>
    );
  }
}
CommitteeForm.contextType = OrgContext;
export default withTranslation(["committee", "common"])(CommitteeForm);
